// extracted by mini-css-extract-plugin
export var activeDot = "_83-c";
export var buttonContainer = "_83-9";
export var channelButton = "_83-a";
export var clickable = "_83-d";
export var content = "_83-0";
export var contentFull = "_83-2";
export var contentThird = "_83-1";
export var contentWrapper = "_83-7";
export var description = "_83-5";
export var heightShort = "_83-f";
export var image = "_83-3";
export var imageContainer = "_83-4";
export var selectButton = "_83-e";
export var spinnerContainer = "_83-b";
export var titleContent = "_83-8";
export var titleWrapper = "_83-6";